import React, { useState } from 'react';
import PropTypes from 'prop-types';

interface IProps {
  id: string,
  value: number | string,
  type: string,
  callBack: any,
  cast: any,
  parse: any
}

export default function InputAny(props: IProps) {
  const [value, setValue] = useState(props.cast(props.value));

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  }

  const onBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value  = props.parse(event.target.value);
    props.callBack(value);
    setValue(props.cast(value));
  }

  return (
      <input
        key={`input-${props.id}`}
        type={props.type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        checked={value as boolean} />
    );
}

InputAny.propTypes = {
  key: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  callBack: PropTypes.func,
  parse: PropTypes.func,
  cast: PropTypes.func,
};